




















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ServerResult } from '@/core/http/server_result';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';

import ClientComplaintsForm from '../../ClientComplaintsForm/ClientComplaintsForm.vue';

export const CONTACTS_LIST = 'CONTACTS_LIST';
export const DELIVERY_POINT_LIST = 'DELIVERY_POINT_LIST';
export const COUNTERPARTIE_LIST = 'COUNTERPARTIE_LIST';

@Component
export default class ClientComplaints extends Vue {

  @Prop() clientId!: string;

  meta = {};
  documents = [];
  loading = false;

  loadData() {
    this.loading = true;

    (this as any).$db([
      (this as any).$q(CONTACTS_LIST)
        .select()
        .fileds({
          id: "complaints.id",
          created_at: "complaints.created_at",
          description: "complaints.description",
          deals: {
            $array_agg: {
              $obj: {
                deal_id: "deals.id",
                address: "delivery_points.address",
                delivery_date: "deals.expected_delivery_date",
              }
            }
          },
        })
        .from('complaints')
        .innerJoin('complaints_deals', (_: any) => {
          return _.eq("complaints_deals.complaint_id", "complaints.id");
        })
        .innerJoin('deals', (_: any) => {
          return _.and([
            _.eq("complaints_deals.deal_id", "deals.id"),
            _.eq("deals.client_id", _.const(this.clientId))
          ])
        })
        .innerJoin('delivery_points', (_: any) => {
          return _.eq("deals.delivery_point_id", "delivery_points.id");
        })
        .order((_: any) => {
          return [
              _.desc([`complaints.created_at`]),
          ];
        })
        .group([
          'complaints.id',
          'complaints.created_at',
          'complaints.description',
        ])
    ]).then((result: ServerResult) => {
      const opResult = result.getOperation(CONTACTS_LIST).getContent();

      this.meta = fetchEnumsFromSchema(opResult.schema)
      this.documents = opResult.documents

    }).finally(() => {
      this.loading = false;
    });
  }

  // ---------------------------------------------------------------------------

  openDocument(row: any, isNew: boolean = false) {
    this.$buefy.modal.open({
      component: ClientComplaintsForm,
      props: {
        isNew,
        documentPreview: row,
        initParams: {
          clientId: this.clientId
        }
      },
      events: {
        'form-close': () => {
          this.loadData();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  // ---------------------------------------------------------------------------

  mounted() {
    this.loadData();
  }
}

